import React from 'react';

function Footer() {
  return (
    <div className='bg-white'>
      <div className='lg:w-11/12 mx-auto'>
        <p className='text-sm p-4'>{new Date().getFullYear()} © kekere.</p>
      </div>
    </div>
  );
}

export default Footer;
